/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   handleViewStateChange thunk
 *                perform necessary actions when map's viewState updates.
 */

import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import type { GetState } from '@zcode/state-type'
import { hideMarkers } from '../../currentSearchView/actions'
import type { Dispatch, ViewState } from '../../types'
import { unsync } from '../actions'
import {
  selectMapFrozenZoom,
  selectMapReady,
  selectMapSyncDisabled,
  selectMapZoom,
} from '../selectors'
import { updateViewState } from './updateViewState'

export const handleViewStateChange =
  (viewState: ViewState) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const ready = selectMapReady(state)
    const isMobile = selectIsMobile(state)
    // Check that syncing is enabled.
    // If enabled, we note that map has changed and, therefore, `unsynced`.
    const syncDisabled = selectMapSyncDisabled(state)
    if (ready && !syncDisabled) {
      dispatch(unsync())
    }

    const zoom = selectMapZoom(state)
    const frozenZoom = selectMapFrozenZoom(state)

    if (!isMobile && !frozenZoom && viewState.zoom !== zoom) {
      dispatch(hideMarkers())
    }

    dispatch(updateViewState(viewState))
  }
